import React from "react";
import Footer from "../../components/Footer";
import Mbbs from "../../components/Mbbs";
import NavBar from "../../components/navbar/NavBar";

const MbbsPage = () => {
  return (
    <div>
      <NavBar />
      <Mbbs />
      <Footer />
    </div>
  );
};

export default MbbsPage;
